import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface SummarizedCheckboxProps {
  checked: boolean;
  onToggle: () => void;
  /** По-дребен вариант за телефон. */
  small?: boolean;
}

/** Чекбоксът „Обобщено" за детайлите на масата — същият стил като в
 *  „Преглед на поръчката". На десктоп е долу вдясно в детайлите, точно над
 *  лентата с бутоните; под десктоп — на линията на първия часови разделител. */
export const SummarizedCheckbox = ({
  checked,
  onToggle,
  small,
}: SummarizedCheckboxProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={checked}
      className={`inline-flex items-center gap-1.5 border-0 bg-transparent p-0 font-semibold cursor-pointer transition-colors ${
        small ? "text-[11px]" : "text-[12.5px]"
      } ${checked ? "text-pos-accent" : "text-pos-ink2"}`}
    >
      <span
        className={`grid flex-shrink-0 place-items-center rounded-[5px] border ${
          small ? "h-3.5 w-3.5" : "h-4 w-4"
        } ${
          checked
            ? "border-pos-accent bg-pos-accent text-white"
            : "border-pos-check bg-pos-card"
        }`}
      >
        {checked && (
          <CheckOutlined className={small ? "text-[8px]" : "text-[9px]"} />
        )}
      </span>
      {t("ordering.summarized")}
    </button>
  );
};
